<template>
	<div class="issueInfo">
		<slot :info="info" :countDown="countDown" :upTimeData="upTimeData">{{ LgId }}:期号信息</slot>
	</div>
</template>

<script>
/**
 * 期号信息,通过slot传入结构 2020/12/17
 * @param LgId * 传入游戏ID,用于获取游戏当前可以投注的期号信息
 * @param EnabledIssue 启用开奖期号的重复请求,每5秒一次 默认 false 节约网络资源
 * @return info 开奖期号相关信息的集合
 * @return countDown 传回倒计时组件所需的剩余时间
 * @return upTimeData 倒计时结束后的回调方法
 */
import { getAjax } from "../../util/ajax";
import countDown from "./countDown";

export default {
	name: "issueInfo",
	props: {
		LgId: {
			type: Number,
			required: true,
		},
		enabledIssue: {
			type: Boolean,
			default: false,
		},
	},

	components: { countDown },
	data() {
		return {
			info: {
				LastOpenNumberFormat: { state: false, arr: ["?", "?", "?", "?", "?"] }, //格式化后的开奖号码
			},
			countDown: {}, //投注倒计时
		};
	},
	methods: {
		upTimeData() {
			this.getBetLssueInfo(this.LgId);
		},
		// 获取游戏当前可以投注的期号信息-可能包含开奖号码
		getBetLssueInfo(lgId = Number, callBack) {
			let that = this;
			let url = `Api/Lssue/GetBetLssueInfo?lgId=${lgId}`;
			that.countDown = { state: false };
			getAjax(url, {}).then(function (data) {
				if (data.IsSucess) {
					callBack && callBack(data.Data);
					// 将数据抛出
					that.info["LastLssueFormat"] = data.Data.LastLssueFormat; // 上期期号
					that.info["NowLssueFormat"] = data.Data.NowLssueFormat; // 本期期号
					that.info["LastOpenNumber"] = data.Data.LastOpenNumber; // 上期开奖号-此处可能为空
					Object.assign({ ...that.info }, { ...data.Data });

					that.testOpenNumber(data.Data);
					that.countDown = {
						time: data.Data.NowLssueRemainTime, // 开奖倒计时秒数
						state: true,
					};
				}
			});
		},
		// 获取开奖号码
		getLssueOpenInfo(lgId = Number, lssue = String, callBack) {
			let that = this;
			let url = `Api/Lssue/GetLssueOpenInfo?lgId=${lgId}&lssue=${lssue}`;
			getAjax(url, {}).then(function (data) {
				if (data.IsSucess) {
					callBack && callBack(data.Data);
					that.testOpenNumber(data.Data);
				}
			});
		},
		// 检测上期开奖号&重复发起请求
		testOpenNumber(data) {
			if (!(data.LastOpenNumber == null || data.LastOpenNumber === "")) {
				// 将数据抛出
				this.info.LastOpenNumberFormat = { state: true, arr: data.LastOpenNumber.split(",") };
				// 清除倒计时
				clearInterval(this.timer);
				this.timer = null;
			} else {
				// 如果没有开奖号，开始执行倒计时请求开奖号码
				this.setTimer();
			}
		},
		// 设置倒计时请求开奖号码
		setTimer() {
			let that = this;
			if (that.enabledIssue === true && this.timer == null) {
				this.timer = setInterval(() => {
					that.getLssueOpenInfo(this.LgId, this.info.NowLssueFormat);
				}, 5000);
			}
		},
	},
	mounted() {
		this.getBetLssueInfo(this.LgId);
	},
	beforeDestroy() {
		clearInterval(this.timer);
	},
};
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/common/issueInfo.vue